// extracted by mini-css-extract-plugin
export default {"cardsContainer":"BillCards_cardsContainer__a1qXj","cards":"BillCards_cards__hBPay","paginationContainer":"BillCards_paginationContainer__YPTjn"};